import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { fetchJobsList } from '../lib/bridge';
import { LoadingState } from '../components/ui/LoadingState';
import { ErrorState } from '../components/ui/ErrorState';
import { EmptyState } from '../components/ui/EmptyState';
import { PageHeader } from '../components/ui/PageHeader';
import { Badge } from '../components/ui/Badge';
import { fieldControlClass } from '../components/ui/forms';

export function JobsPage() {
  const [search, setSearch] = useState('');
  const query = useQuery({ queryKey: ['jobs', search], queryFn: () => fetchJobsList(search) });

  return (
    <div className="space-y-4">
      <PageHeader eyebrow="Operations" title="Jobs" />
      <div className="relative max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" aria-hidden="true" />
        <input className={`${fieldControlClass} pl-9`} placeholder="Search jobs…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      {query.isLoading && <LoadingState label="Loading jobs…" />}
      {query.isError && (
        <ErrorState message={query.error instanceof Error ? query.error.message : 'Could not load jobs.'} onRetry={() => query.refetch()} />
      )}
      {query.data && !query.data.ok && <ErrorState message={query.data.message || 'Could not load jobs.'} onRetry={() => query.refetch()} />}
      {query.data?.ok && (query.data.jobs?.length ?? 0) === 0 && <EmptyState>No jobs found.</EmptyState>}
      {query.data?.ok && (query.data.jobs?.length ?? 0) > 0 && (
        <ul className="space-y-2">
          {query.data.jobs!.map((job) => (
            <li key={job.jobId}>
              <Link
                to={`/jobs/${encodeURIComponent(job.jobId)}`}
                className="flex items-center justify-between gap-3 rounded-xl border border-ink-border bg-ink-surface p-4 shadow-card transition hover:border-gold-700/60 hover:bg-ink-raised"
              >
                <div className="min-w-0">
                  <p className="truncate font-semibold text-white">{job.customer || job.jobId}</p>
                  <p className="truncate text-sm text-slate-400">{job.project || job.address || job.jobId}</p>
                </div>
                <Badge tone="gold" className="shrink-0">
                  {job.stage || job.estimateStatus || '—'}
                </Badge>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
